"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tags = _interopRequireDefault(require("../../../../utils/helpers/tags"));

var _sidebarHeader = _interopRequireDefault(require("./sidebar-header.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const SidebarHeader = ({
  className,
  children,
  ...props
}) => /*#__PURE__*/_react.default.createElement(_sidebarHeader.default, _extends({
  className: className
}, (0, _tags.default)("sidebar-header", props)), children);

SidebarHeader.propTypes = {
  /** This component supports children. */
  children: _propTypes.default.node,

  /** A custom class name. */
  className: _propTypes.default.string
};
var _default = SidebarHeader;
exports.default = _default;